import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../gen/rbt/cloud/v1alpha1/user/user_rbt_react";

/**
 * Hook that resolves the signed-in user from the backend OAuth
 * session.
 *
 * The Reboot client manages the session (and its bearer token)
 * itself; this hook resolves the signed-in user, and sends a
 * signed-out visitor to the login page (which starts the backend's
 * OAuth flow and returns them to the page they wanted).
 *
 * Returns undefined until the signed-in user is known.
 */
export function useAuthenticatedSession() {
  const { user, isLoading } = useUser();
  const navigate = useNavigate();

  const signedOut = !isLoading && user === undefined;

  useEffect(() => {
    if (signedOut) {
      const returnTo = encodeURIComponent(window.location.href);
      navigate(`/login?return_to=${returnTo}`, { replace: true });
    }
  }, [signedOut, navigate]);

  if (user === undefined) {
    return undefined;
  }

  return {
    userId: user.state_id,
  };
}
